import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TrackingProp } from 'react-tracking';

import { useTrackCLPEmptyResults } from 'analytics/itly/hooks';
import { filterStateSelector } from 'store/ui/selectors';
import { clearFilterState } from '../../store/ui/actions';
import { ClearFiltersButton, EnvelopeSvgWrapper, NoResultsWrapper } from '../../components/ProductGrid/styled';
import Envelope2Svg from '../../icons/Envelope2.svg';
import { isNotServerSideRendering } from 'helpers/env';
import SvgContainer from 'icons/SvgContainer';
import styled from 'styled-components';

const EnvelopeSvgContainer = styled.span`
  height: 10rem
`;

const NoElements = ({ tracking }: { tracking: TrackingProp }): React.JSX.Element => {
  const filterState = useSelector(filterStateSelector);
  useTrackCLPEmptyResults(tracking, filterState);
  const dispatch = useDispatch();

  const handleClearFilters = () => {
    if (isNotServerSideRendering()) {
      window.scrollTo(0, 0);
      window.location.search = '';
      dispatch(clearFilterState());
    }
  };
  return (
    <>
      <EnvelopeSvgWrapper>
        <EnvelopeSvgContainer>
          {SvgContainer(Envelope2Svg)}
        </EnvelopeSvgContainer>
      </EnvelopeSvgWrapper>
      <NoResultsWrapper>
          <h4 style={{ marginBottom: '0.5rem' }}>Discover More Cards</h4>
          <p>To see more of our collection, try modifying one of your active filters.</p>
        <ClearFiltersButton onClick={handleClearFilters}>REMOVE ALL FILTERS</ClearFiltersButton>
      </NoResultsWrapper>
    </>
  );
};

export default NoElements;
